<template>
  <fn-button-add-to-cart
    :data-audience="dataAudience"
    :data-name="dataName"
    :disabled="isButtonDisabled"
    :hide-tooltip="hideTooltip"
    :quinary-alt="quinaryAlt"
    :secondary="secondary"
    :status="status"
    :text="text"
    @add-to-cart="handleAddToCart"
  />
</template>

<script>
import { inStock } from '@/utils/stock';

export default defineComponent({
  props: {
    text: {
      type: String,
      default: '',
    },
    secondary: {
      type: Boolean,
    },
    quinaryAlt: {
      type: Boolean,
    },
    stock: {
      type: Object,
      default: () => ({}),
    },
    code: {
      type: [String, Number, Array],
      default: '',
    },
    quantity: {
      type: Number,
      default: 1,
    },
    disabled: {
      type: Boolean,
    },
    dataName: {
      type: String,
      default: '',
    },
    dataAudience: {
      type: String,
      default: '',
    },
    stockBypass: {
      type: Boolean,
    },
  },
  emits: ['addToCart', 'finishedAdding', 'addToCartOverlay'],
  data() {
    return {
      status: null,
    };
  },
  computed: {
    ...mapState(useMainStore, {
      ecomEnabledApp: 'getEcomEnabledApp',
      isAppview: 'isAppview',
    }),
    hasStock() {
      if (!this.stock) return true;

      return inStock(this.stock.stockLevelStatus);
    },
    hideTooltip() {
      return (
        !!this.code.length &&
        this.status !== 'lowStock' &&
        this.status !== 'maxOrderQuantityExceeded' &&
        this.status !== 'itemLimitExceeded'
      );
    },
    isButtonDisabled() {
      if (this.disabled) return true;
      if (this.stockBypass) return false;
      return !this.hasStock;
    },
  },
  methods: {
    ...mapActions(useCartStore, {
      addEntry: 'addEntry',
    }),

    async handleAddToCart() {
      if (this.isAppview && !this.ecomEnabledApp) {
        return window.open(this.$route.path, '_blank');
      }

      if (this.status === 'success' && !this.isAppview) {
        await navigateTo({ path: this.$t('url.cart') });
        return;
      }

      this.status = 'loading';

      let productCodes = this.code;

      if (!Array.isArray(this.code)) {
        productCodes = [this.code];
      }

      const results = [];

      try {
        for (const code of productCodes) {
          results.push(
            await this.addEntry({
              productCode: code,
              quantity: this.quantity,
            }),
          );
        }
        // For now, just take the first result for the overall status
        // because adding multiple products is an MVP and should stay lightweight
        this.status = results[0].statusCode;

        // we display the add to cart overlay in case we don't have this status or the low stock statuses
        if (
          results[0].statusCode !== 'lowStock' &&
          results[0].statusCode !== 'maxOrderQuantityExceeded' &&
          results[0].statusCode !== 'itemLimitExceeded'
        ) {
          this.$emit('addToCartOverlay', results[0]);
        }
      } catch (error) {
        this.status = 'error';
      }

      this.$emit('finishedAdding', results);

      setTimeout(() => {
        this.status = null;
      }, 5000);
    },
  },
});
</script>
